var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47.5 50.4",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,37.6h-9.6c-1.8,0-3.2,1.4-3.2,3.2c0,1.4,1,2.6,2.3,3l1.8,3.8c0.2,0.3,0.5,0.6,0.9,0.6h6.1 c0.4,0,0.7-0.2,0.9-0.6l1.8-3.8c1.3-0.4,2.3-1.6,2.3-3C32.1,39,30.7,37.6,29,37.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.1,6.2c0.6,0,1-0.4,1-1V2.9c0-0.6-0.4-1-1-1s-1,0.4-1,1v2.3C23.1,5.7,23.6,6.2,24.1,6.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.2,7.3c0.5,0.2,1.1,0,1.3-0.5l0.8-2c0.2-0.5,0-1.1-0.5-1.3s-1.1,0-1.3,0.5l-0.8,2 C29.4,6.5,29.7,7.1,30.2,7.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.7,10.7l1.5-1.5c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-1.5,1.5c-0.4,0.4-0.4,1,0,1.4 C35.7,11.1,36.3,11.1,36.7,10.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6,10.7c0.4,0.4,1,0.4,1.4,0s0.4-1,0-1.4l-1.5-1.5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L11.6,10.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.8,6.8c0.2,0.5,0.8,0.8,1.3,0.5c0.5-0.2,0.8-0.8,0.5-1.3l-0.8-2c-0.2-0.5-0.8-0.8-1.3-0.5 C16,3.7,15.7,4.3,16,4.8L16.8,6.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.9,33.5c0.9,0.8,1.5,1.7,1.9,2.7c0.7-0.4,1.6-0.7,2.5-0.7h3.8V25.1l-1.6-1l-2.1,1.3 c-0.2,0.1-0.3,0.2-0.5,0.2c-0.3,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.3-1.4l2.6-1.6c0.3-0.2,0.7-0.2,1.1,0l2.1,1.3l2.1-1.3 c0.3-0.2,0.7-0.2,1.1,0l2.6,1.6c0.5,0.3,0.6,0.9,0.3,1.4s-0.9,0.6-1.4,0.3l-2.1-1.3l-1.6,1v10.5h3.8c0.9,0,1.8,0.2,2.5,0.7 c0.4-1,1.1-1.9,2-2.7c3.2-2.7,5.1-6.7,5.1-10.9c0-8.1-6.8-14.7-15-14.3c-7.4,0.3-13.4,6.4-13.7,13.9C9.7,26.5,11.5,30.7,14.9,33.5 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKnowledge);
export default __webpack_public_path__ + "static/media/icon-knowledge.75d0a4e045e40454db9703c7d092373e.svg";
export { ForwardRef as ReactComponent };